<irembogov-irembo-date-picker
  [formControl]="formControl"
  ngDefaultControl
  [maxDate]="props['maxDate']"
  [addRemoveTimeMinDate]="props['addRemoveTimeMinDate']"
  [addRemoveTimeMaxDate]="props['addRemoveTimeMaxDate']"
  [allowedDaysOfTheWeek]="props['allowedDaysOfTheWeek']"
  [minDate]="props['minDate']"
  [placeholder]="props['placeholder']"
  [dateFormat]="props['dateFormat']"
  [eventCode]="props['eventCode']"
  [eventDatesMaxSize]="props['eventDatesMaxSize']"
  [delimeter]="props['delimeter']"
  [excludedDates]="props['excludedDates']">
</irembogov-irembo-date-picker>
